// src/services/financeOutcomesService.js
import { fetchWithAuth } from '../utils/fetchWithAuth';

const enc = (v) => encodeURIComponent(String(v ?? ''));
const qstr = (params = {}) =>
  new URLSearchParams(
    Object.entries(params).filter(([, v]) => v != null && v !== '')
  ).toString();

/* =============== Conceptos =============== */
export const listOutcomeConcepts = async (rut) => {
  const qs = rut && rut !== '*' ? `?rut=${enc(rut)}` : '';
  // backend: GET /finance/outcomes/concepts/list
  const res = await fetchWithAuth(`/finance/outcomes/concepts/list${qs}`, { method: 'GET' });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
};

export const upsertOutcomeConcept = async ({ rut, code, name, active = true }) => {
  // backend: POST /finance/outcomes/concepts/upsert
  const res = await fetchWithAuth(`/finance/outcomes/concepts/upsert`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ rut, code, name, active }),
  });
  if (!res.ok) {
    const e = await res.json().catch(() => ({}));
    throw new Error(e.message || `HTTP ${res.status}`);
  }
  return res.json();
};

/* =============== Egresos (CRUD) =============== */
export const listOutcomes = async (params = {}) => {
  const qs = qstr(params);
  const url = `/finance/outcomes${qs ? `?${qs}` : ''}`;
  const res = await fetchWithAuth(url, { method: 'GET' });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
};

export const createOutcome = async (payload) => {
  const res = await fetchWithAuth(`/finance/outcomes`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const e = await res.json().catch(() => ({}));
    throw new Error(e.message || `HTTP ${res.status}`);
  }
  return res.json();
};

export const updateOutcome = async (id, payload) => {
  const res = await fetchWithAuth(`/finance/outcomes/${enc(id)}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const e = await res.json().catch(() => ({}));
    throw new Error(e.message || `HTTP ${res.status}`);
  }
  return res.json();
};

export const deleteOutcome = async (id) => {
  const res = await fetchWithAuth(`/finance/outcomes/${enc(id)}`, { method: 'DELETE' });
  if (!res.ok) {
    const e = await res.json().catch(() => ({}));
    throw new Error(e.message || `HTTP ${res.status}`);
  }
  return res.json();
};

